
import React, { useState, useEffect, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/yapa-logo.png";
import "./StarsTable.css";
import GridNotification from "../GridPage/DataGrid/GridNotification/GridNotification";
import { AlertColor } from '@mui/material/Alert';


const StarsTable = () => {
    const [items, setItems] = useState<string[]>([]);
    const [filteredItems, setFilteredItems] = useState<string[]>([]);

    const [notificationOpen, setNotificationOpen] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [notificationSeverity, setNotificationSeverity] = useState<AlertColor>('success');
    const [searchQuery, setSearchQuery] = useState<string>("");

    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const getStarBands = useCallback(async () => {
      try {
        const response = await axiosPrivate.get("/bands/stars");
        const starBands = response.data.map((band: { nazwa: string }) => band.nazwa);
        setItems(starBands);
        setFilteredItems(starBands);
      } catch (error) {
        console.error("Błąd podczas pobierania gwiazd:", error);
        setItems([]);
        setFilteredItems([]);
      }
    }, [axiosPrivate]);
    
    useEffect(() => {
      getStarBands();
    }, [getStarBands]);

    const handleEdit = async (artistName: string) => {
      try {
        const response = await axiosPrivate.get(`/bands/id/${artistName}`);
        const bandId = response.data.id;
    
        if (bandId) {
          sessionStorage.setItem("starId", bandId.toString());
          navigate("/artists1");
        } else {
          console.error("Nie znaleziono ID zespołu dla:", artistName);
        }
      } catch (error) {
        console.error("Błąd pobierania ID zespołu:", error);
      }
    };
    
    
  
    const handleDelete = async (index: number) => {
      const artistName = filteredItems[index];
      try {
        const response = await axiosPrivate.delete(`/bands/${artistName}`);
        if (response.status === 200) {
          const updatedItems = items.filter((_, i) => i !== index);
          setItems(updatedItems);
          setFilteredItems(updatedItems);

          setNotificationMessage(`Zespół "${artistName}" został usunięty.`);
          setNotificationSeverity('success');
          setNotificationOpen(true);
        }
      } catch (error: any) {
        if (error.response && error.response.status === 400) {
          setNotificationMessage(error.response.data.error);
          setNotificationSeverity('error');
          setNotificationOpen(true);
        } else {
            console.error("Błąd podczas usuwania gwiazdy:", error);
        }
    }
    };
    
  useEffect(() => {
        const filtered = items.filter((band) =>
          band.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredItems(filtered);
  }, [items, searchQuery]);

    const NavigateToAddingStars = () =>{
      sessionStorage.setItem("isAddingStar", "true"); 
      navigate('/artists1');
    }
  
    return (
      <div className="artists-container">
         <GridNotification
            open={notificationOpen}
            setOpen={setNotificationOpen}
            message={notificationMessage}
            severity={notificationSeverity}
        />
        <div>
          <img src={logo} alt="Yapa Logo" className="logo" />

          <div className="artists-header-filters">
            <input
              className="modal-input"
              type="text"
              placeholder="Szukaj..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <h1>GWIAZDY ⭐</h1>
            <div className="artist-fill"></div>
          </div>
          <div className="table-actions-container">
            <div className="table-container">
              <table className="artists-table">
                <thead>
                  <tr>
                    <th>Nazwa zespołu</th>
                    <th>
                      <span className="desktop-header">Edycja i usuwanie</span>
                      <span className="mobile-header">Edycja</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems.map((artist, index) => (
                    <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                      <td>{artist}</td>
                      <td>
                        <button
                          className="btn icon-btn"
                          onClick={() => handleEdit(artist)}
                        >
                          ✏️
                        </button>
                        <button
                          className="btn icon-btn"
                          onClick={() => handleDelete(index)}
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="actions">
              <button className="btn" onClick={NavigateToAddingStars}>
                Dodaj
              </button>
              <button className="btn" onClick={() => navigate(-1)}>
                Wróć
              </button>
            </div>
          </div>
        </div>
      </div>

    );
  };
  
  export default StarsTable;